/**
 * Created by sugimoto on 2016/12/19.
 */
import React, {Component, PropTypes} from "react";
import Modal from "react-modal";
import axios from "axios";
import ReactCookie from "react-cookie";
import update from "immutability-helper";
import {initValidation} from 'react-custom-validation';
import {sprintf} from "sprintf-js";
import url from "url";
import ClipMenu from './ClipMenu';
import SendEmailForm from './SendEmailForm';
import {SearchWebUtils} from '@aperza/react-ui';

export default class Clip extends Component {
    constructor(props) {
        super(props);

        this.state ={
            isClipOpen : false,
            isClipYetLoginOpen:false,
            isClipSuccessModal:true,
            isClipHideOpen:false,
            isMailClipOpen : false,
            isMailClipSuccessOpen: false,
            isMailClipSuccessModal:true,
            isMailClipHideOpen:false,
            isClipboardCopyOpen: false,
            isAddBookmarkOpen:false,
            isLogin: false,
            loginUrl:undefined,
            token:undefined,
            user:undefined,
            fields:{email: ""},
            validations: {email: initValidation()}
        };

        this.onMailClipSubmit = this.onMailClipSubmit.bind(this);

        this.openClipModal = this.openClipModal.bind(this);
        this.closeClipModal = this.closeClipModal.bind(this);
        this.afterClipModal = this.afterClipModal.bind(this);

        this.closeClipHideModal = this.closeClipHideModal.bind(this);
        this.afterClipHideModal = this.afterClipHideModal.bind(this);
        this.hideClipSuccessModal = this.hideClipSuccessModal.bind(this);

        this.closeClipYetLoginModal = this.closeClipYetLoginModal.bind(this);
        this.afterClipYetLoginModal = this.afterClipYetLoginModal.bind(this);

        this.closeMailClipSuccessModal = this.closeMailClipSuccessModal.bind(this);
        this.afterMailClipSuccessModal = this.afterMailClipSuccessModal.bind(this);
        this.hideMailClipSuccessModal = this.hideMailClipSuccessModal.bind(this);

        this.closeMailClipHideModal = this.closeMailClipHideModal.bind(this);
        this.afterMailClipHideModal = this.afterMailClipHideModal.bind(this);

        this.openMailClipModal = this.openMailClipModal.bind(this);
        this.closeMailClipModal = this.closeMailClipModal.bind(this);
        this.afterMailClipModal = this.afterMailClipModal.bind(this);

        this.openClipBoardCopyModal = this.openClipBoardCopyModal.bind(this);
        this.closeClipboardCopyModal = this.closeClipboardCopyModal.bind(this);
        this.afterClipboardCopyModal = this.afterClipboardCopyModal.bind(this);

        this.addBookmark = this.addBookmark.bind(this);
        this.closeAddBookmarkModal = this.closeAddBookmarkModal.bind(this);
        this.afterAddBookmarkModal = this.afterAddBookmarkModal.bind(this);
    }

    componentWillMount = () => {
        let checkToken = ReactCookie.load(AUTH_COOKIE_NAME);
        let self = this;
        if( window.fetch !== undefined ) {
            fetch(VALIDATE_URL, {
                method: "GET",
                headers: {
                    'Authorization': checkToken
                }
            }).then(
                response => response.json().then(data => {
                    if( data.valid ) {
                        self.setState ({
                                isLogin: data.valid,
                                token: checkToken,
                                user: data
                            });
                            // LocalStrageにあるデータを登録する。
                    }
                }
            ))
            .catch(function(error) {

            });
        } else {
            //For IE11

            let xhr = new XMLHttpRequest();

            xhr.onreadystatechange = function() {
                if( this.readyState == 4 && this.status == 200 ) {
                    try {
                        if (!this.response) return;
                        let data = JSON.parse(this.response);
                        if( data && data.valid ) {
                            self.setState ({
                                isLogin: data.valid,
                                token: checkToken,
                                user: data
                            });
                            // LocalStrageにあるデータを登録する。
                        }
                    } catch(error) {
                      if (AUTH_COOKIE_NAME !== 'atkn') {
                            console.error(this.response);
                            console.error(error.stack);
                        }
                    }
                }
            }

            xhr.open("GET", VALIDATE_URL, true);
            xhr.setRequestHeader('Authorization', checkToken);
            xhr.responseType = 'json';
            xhr.send(null);
        }
        let isClipSuccessModal = localStorage.getItem("isClipSuccessModal");
        let isMailClipSuccessModal = localStorage.getItem("isMailClipSuccessModal");
        isClipSuccessModal = isClipSuccessModal != null ? JSON.parse(isClipSuccessModal) : true;
        isMailClipSuccessModal = isMailClipSuccessModal != null ? JSON.parse(isMailClipSuccessModal) : true;

        localStorage.setItem("isClipSuccessModal", isClipSuccessModal);
        localStorage.setItem("isMailClipSuccessModal", isMailClipSuccessModal);
        this.setState({
            "isClipSuccessModal": isClipSuccessModal,
            "isMailClipSuccessModal": isMailClipSuccessModal,
            "loginUrl":this.getLoginUrl()
        });
    }

    openClipModal = (event) => {
        event.preventDefault();
        let data = {
            contents_type: this.props.contentsType,
            contents_detail_type: this.props.contentsDetailType,
            contents_key: this.props.clipUrl,
            service_id: this.props.serviceId,
            region: 'JP',
            lang: 'ja',
            contents_title: this.props.clipTitle,
            contents_image_url: this.props.clipImageUrl
        };
        if( this.state.isLogin ){
            let that = this;
            if( window.fetch !== undefined ) {
                fetch(CLIP_URL, {
                    method: 'POST',
                    headers: {
                        'Authorization': this.state.token,
                        'Content-Type':'application/json'
                    },
                    body: JSON.stringify(data)
                })
                .then(response => response.json().then(data => {
                    if( data.data ) {
                        console.log(data);
                        if( that.state.isClipSuccessModal ){
                            that.setState({isClipOpen: !that.state.isClipOpen});
                        }else{
                            that.setState({isClipHideOpen: !that.state.isClipHideOpen});
                        }
                    }else{
                        if( data.errors.message.includes("already") ){
                            if( that.state.isClipSuccessModal ){
                                that.setState({isClipOpen: !that.state.isClipOpen});
                            }else{
                                that.setState({isClipHideOpen: !that.state.isClipHideOpen});
                            }
                        }
                    }
                    that.refs.clipSuccessBaloon.style.opacity=1;
                    setTimeout(function() {
                        that.refs.clipSuccessBaloon.style.opacity=0;
                    },3000);
                }))
                .catch(function(error){

                });
            } else {
                let that = this;
                $.ajax({
                    url: CLIP_URL,
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(data),
                    headers: {
                        'Authorization': this.state.token,
                        'Content-Type':'application/json'
                    }
                })
                .done(function(data){
                    if( data.data ) {
                        if( that.state.isClipSuccessModal ){
                            that.setState({isClipOpen: !that.state.isClipOpen});
                        }else{
                            that.setState({isClipHideOpen: !that.state.isClipHideOpen});
                        }
                    }else{
                        if( data.errors.message.includes("already") ){
                            if( that.state.isClipSuccessModal ){
                                that.setState({isClipOpen: !that.state.isClipOpen});
                            }else{
                                that.setState({isClipHideOpen: !that.state.isClipHideOpen});
                            }
                        }
                    }
                    that.refs.clipSuccessBaloon.style.opacity=1;
                    setTimeout(function() {
                        that.refs.clipSuccessBaloon.style.opacity=0;
                    },3000);
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    console.error(textStatus);
                });
            }
         } else {
            this.setState({isClipYetLoginOpen: !this.state.isClipYetLoginOpen});
        }
    }

    closeClipModal = () => {
        this.refs.clipModal.portal.refs.content.style.opacity=0;
        this.refs.clipModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function() {
            that.setState({isClipOpen : !that.state.isClipOpen});
        },600);
    }

    afterClipModal = () => {
        this.refs.clipModal.portal.refs.overlay.style.opacity=1;
        this.refs.clipModal.portal.refs.content.style.opacity=1;
    }

    closeClipHideModal = () =>  {
        this.refs.clipHideModal.portal.refs.content.style.opacity=0;
        this.refs.clipHideModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function() {
            that.setState({isClipHideOpen: !that.state.isClipHideOpen});
        },600);
    }

    afterClipHideModal = () => {
        this.refs.clipHideModal.portal.refs.overlay.style.opacity=1;
        this.refs.clipHideModal.portal.refs.content.style.opacity=1;
        let that = this;
        setTimeout(function(){
            if( that.state.isClipHideOpen ){
                that.closeClipHideModal();
            }
        },3000);
    }

    hideClipSuccessModal = () => {
        let checked = this.refs.clipHide.checked;
        localStorage.setItem("isClipSuccessModal", !checked);
        this.setState({"isClipSuccessModal": !checked});
    }

    closeClipYetLoginModal = () =>  {
        this.refs.clipYetLoginModal.portal.refs.content.style.opacity=0;
        this.refs.clipYetLoginModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function(){
            that.setState({isClipYetLoginOpen : !that.state.isClipYetLoginOpen});
        },600);

    }

    afterClipYetLoginModal = () => {
        if (this.refs.clipYetLoginModal.portal.refs.overlay) {
            this.refs.clipYetLoginModal.portal.refs.overlay.style.opacity = 1;
        }
        if (this.refs.clipYetLoginModal.portal.refs.content) {
            this.refs.clipYetLoginModal.portal.refs.content.style.opacity = 1;
        }
    }

    openMailClipModal = (event) =>  {
        event.preventDefault();
        this.setState({isMailClipOpen : !this.state.isMailClipOpen});
    }

    closeMailClipModal = () => {
        this.refs.mailClipModal.portal.refs.content.style.opacity=0;
        this.refs.mailClipModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function(){
            that.setState({isMailClipOpen : !that.state.isMailClipOpen});
        },600);
    }

    afterMailClipModal = () => {
        this.refs.mailClipModal.portal.refs.overlay.style.opacity=1;
        this.refs.mailClipModal.portal.refs.content.style.opacity=1;
    }

    onMailClipSubmit = (email) =>  {
        let itemPageShown = SearchWebUtils.getItemPageShown();
        let url;

        if (itemPageShown) {
            url = this.state.isLogin ?  MAIL_SEARCH_ITEM_POST_URL : MAIL_SEARCH_ITEM_POST_ANON_URL;
        }
        else {
            url = this.props.serviceId == 2 ? (this.state.isLogin ?  MAIL_ARTICLE_POST_URL : MAIL_ARTICLE_POST_ANON_URL) : (this.state.isLogin ?  MAIL_SEARCH_POST_URL : MAIL_SEARCH_POST_ANON_URL);
        }

        let headers = this.state.isLogin ? {'Authorization': this.state.token, 'Content-Type':'application/json'} : {'Content-Type':'application/json'};
        let data = {
            contents_type: this.props.contentsType,
            contents_detail_type: this.props.contentsDetailType,
            mail_address: email,
            contents_title:this.props.clipTitle,
            contents_key: this.props.clipUrl,
            service_id: this.props.serviceId,
            region: 'JP',
            lang: 'ja'
        };
        let that = this;
        if( window.fetch !== undefined ) {
            fetch(url, {
                method: 'POST',
                headers : headers,
                body: JSON.stringify(data),
                }
            )
            .then(response => response.json().then(data => {
                if( data.data){
                    if( that.state.isMailClipSuccessModal ){
                        that.setState({
                            isMailClipOpen : !that.state.isMailClipOpen,
                            isMailClipSuccessOpen:!that.state.isMailClipSuccessOpen
                        });
                    }else{
                        that.setState({
                            isMailClipOpen : !that.state.isMailClipOpen,
                            isMailClipHideOpen :!that.state.isMailClipHideOpen
                        });
                    }
                }else {
                    that.setState({
                        isMailClipOpen: !that.state.isMailClipOpen
                    });
                }
            }))
            .catch(function(error){
                that.setState({
                    isMailClipOpen: !that.state.isMailClipOpen
                });
            });
        } else {
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(data),
                headers: headers,
            })
            .done(function(data){
                if( data.data ){
                    if( that.state.isMailClipSuccessModal ){
                        that.setState({
                            isMailClipOpen : !that.state.isMailClipOpen,
                            isMailClipSuccessOpen:!that.state.isMailClipSuccessOpen
                        });
                    }else{
                        that.setState({
                            isMailClipOpen : !that.state.isMailClipOpen,
                            isMailClipHideOpen :!that.state.isMailClipHideOpen
                        });
                    }
                }else {
                    that.setState({
                        isMailClipOpen: !that.state.isMailClipOpen
                    });
                }
            })
            .fail(function(jqXHR, testStatus, errorThrown){
                console.error(textStatus);
                that.setState({
                    isMailClipOpen: !that.state.isMailClipOpen
                });
            });
        }
        /*
        axios.post(
            url,
            JSON.stringify(data),
            headers)
            .then(function(response) {
                if( response.data.data){
                    if( that.state.isMailClipSuccessModal ){
                        that.setState({
                            isMailClipOpen : !that.state.isMailClipOpen,
                            isMailClipSuccessOpen:!that.state.isMailClipSuccessOpen
                        });
                    }else{
                        that.setState({
                            isMailClipOpen : !that.state.isMailClipOpen,
                            isMailClipHideOpen :!that.state.isMailClipHideOpen
                        });
                    }
                }else {
                    that.setState({
                        isMailClipOpen: !that.state.isMailClipOpen
                    });
                }
            })
            .catch(function(error){
                that.setState({
                    isMailClipOpen: !that.state.isMailClipOpen
                });
            });*/
    }

    hideMailClipSuccessModal = () => {
        let checked = this.refs.mailClipHide.checked;
        localStorage.setItem("isMailClipSuccessModal", !checked);
        this.setState({"isMailClipSuccessModal": !checked});
    }

    closeMailClipSuccessModal = () => {
        this.refs.mailClipSuccessModal.portal.refs.content.style.opacity=0;
        this.refs.mailClipSuccessModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function(){
            that.setState({isMailClipSuccessOpen : !that.state.isMailClipSuccessOpen});
        },600);
    }

    afterMailClipSuccessModal = () => {
        this.refs.mailClipSuccessModal.portal.refs.overlay.style.opacity=1;
        this.refs.mailClipSuccessModal.portal.refs.content.style.opacity=1;
    }

    closeMailClipHideModal = () => {
        this.refs.mailClipHideModal.portal.refs.content.style.opacity=0;
        this.refs.mailClipHideModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function(){
            that.setState({isMailClipHideOpen :!that.state.isMailClipHideOpen});
        },600);
    }

    afterMailClipHideModal = () => {
        this.refs.mailClipHideModal.portal.refs.overlay.style.opacity=1;
        this.refs.mailClipHideModal.portal.refs.content.style.opacity=1;
        let that = this;
        setTimeout(function(){
            if( that.state.isMailClipHideOpen ){
                that.closeMailClipHideModal();
            }
        },3000);
    }

    openClipBoardCopyModal = () => {
        this.setState({isClipboardCopyOpen : !this.state.isClipboardCopyOpen});
    }

    closeClipboardCopyModal = () => {
        this.refs.clipboardCopyModal.portal.refs.content.style.opacity=0;
        this.refs.clipboardCopyModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function(){
            that.setState({isClipboardCopyOpen : !that.state.isClipboardCopyOpen});
        },600);
    }

    afterClipboardCopyModal = () => {
        this.refs.clipboardCopyModal.portal.refs.overlay.style.opacity=1;
        this.refs.clipboardCopyModal.portal.refs.content.style.opacity=1;
        let that = this;
        setTimeout(function(){
            if( that.state.isClipboardCopyOpen ){
                that.closeClipboardCopyModal();
            }
        },3000);
    }

    getLoginUrl = () => {
        let loginUrl = ID_LOGIN_URL;
        let site = null;

        if( this.props.serviceId == 3 || this.props.serviceId == 5 ){
            site ="login/search-aperza/";

        }else if(this.props.serviceId == 2){
            site ="login/news-aperza/";
        }
        if( site != null ){
            loginUrl += site;
            let nowUrl = url.parse(this.props.clipUrl === window.location.href ? this.props.clipUrl : window.location.href);
            let path = nowUrl.path;
            if( path.length > 1 ){
                loginUrl += "?path=" + encodeURIComponent(path.substring(1));
            }
        }

        return loginUrl;
    }

    addBookmark = (event) => {
        event.preventDefault();
        if (window.sidebar && window.sidebar.addPanel) { // Mozilla Firefox Bookmark
            window.sidebar.addPanel(this.props.clipTitle, this.props.clipUrl,'');
        } else if(window.external && ('AddFavorite' in window.external)) { // IE Favorite
            window.external.AddFavorite(this.props.clipUrl, this.props.clipTitle);
        } else if(window.opera && window.print) { // Opera Hotlist
            this.refs.clipMenu.refs.bookmarkLink.title = this.props.clipTitle;
        } else {

            this.setState({isAddBookmarkOpen : !this.state.isAddBookmarkOpen});
        }
    }

    closeAddBookmarkModal = () => {
        this.refs.addBookmarkModal.portal.refs.content.style.opacity=0;
        this.refs.addBookmarkModal.portal.refs.overlay.style.opacity=0;
        let that = this;
        setTimeout(function(){
            that.setState({isAddBookmarkOpen: !that.state.isAddBookmarkOpen});
        },600);
    }

    afterAddBookmarkModal = () => {
        this.refs.addBookmarkModal.portal.refs.overlay.style.opacity=1;
        this.refs.addBookmarkModal.portal.refs.content.style.opacity=1;
        let that = this;
        setTimeout(function(){
            if( that.state.isAddBookmarkOpen ){
                that.closeAddBookmarkModal();
            }
        },3000);
    }

    fieldChange = (field, value) => {
        this.setState((s) => update(s, {fields: {[field]: {$set: value}}}))
    }

    validationChange = (name, value) => {
        this.setState((s) => update(s, {validations: {[name]: {$set: value}}}))
    }

    render() {
        let overlayBackgoundColor = "rgba(0,0,0,0.7)";
        if( this.state.isClipboardCopyOpen || this.state.isClipHideOpen || this.state.isMailClipHideOpen){
            overlayBackgoundColor = "rgba(255,255,255,0.7)";
        }

        let customStyle= {
            overlay:{
                backgroundColor      : overlayBackgoundColor,
                "-webkit-transition" : "all 0.5s",
                "-moz-transition"    : "all 0.5s",
                "-ms-transition"     : "all 0.5s",
                "-o-transition"      : "all 0.5s",
                transition           : "all 0.5s",
                opacity              : 0,
                zIndex            : 1000
            },
            content:{
                display              : "block",
                top                  : "50%",
                left                 : "50%",
                right                : "auto",
                bottom               : "auto",
                marginRight          : "-50%",
                transform            : "translate(-50%, -50%)",
                "-webkit-transition" : "all 0.5s",
                "-moz-transition"    : "all 0.5s",
                "-ms-transition"     : "all 0.5s",
                "-o-transition"      : "all 0.5s",
                transition           : "all 0.5s",
                opacity              : 0
            }
        };
        const displayNone = {
            "-webkit-transition" : "all 1.5s",
            "-moz-transition"    : "all 1.5s",
            "-ms-transition"     : "all 1.5s",
            "-o-transition"      : "all 1.5s",
            transition           : "all 1.5s",
            opacity              : 0
        };

        let w = window.innerWidth;
        if ( w < 700) {
            customStyle.content.width = (w - 40) + "px";
        }

        let disabledLinks = SearchWebUtils.getDisabledLinks();
        let itemPageShown = SearchWebUtils.getItemPageShown();

        return (
            <ClipMenu
                ref="clipMenu"
                menuType={this.props.menuType}
                clickOpenClip={this.openClipModal}
                clickOpenMailClip={this.openMailClipModal}
                clipBoardSuccess={this.openClipBoardCopyModal}
                addBookmark={this.addBookmark}
                clipTitle={this.props.clipTitle}
                clipUrl={this.props.clipUrl}
                disabledLinks={disabledLinks}
                itemPageShown={itemPageShown}
                serviceId={this.props.serviceId}>
                <Modal
                    isOpen={this.state.isClipOpen}
                    onAfterOpen={this.afterClipModal}
                    onRequestClose={this.closeClipModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper modal_wrapper_bgGreen" : "modal_wrapper modal_wrapper_bgGreen"}
                    style={customStyle}
                    contentLabel="Clip Modal"
                    ref="clipModal"
                    isLogin={this.state.isLogin}>
                        <div className="modal modal-message" ref="clip">
                            <div className="modal_body">
                                <p className="modal_closeBtn"><span className="icon icon-close" onClick={this.closeClipModal}></span></p>
                                <p className="modal_messageIcon">
                                    <span className="icon icon-xl icon-white icon-clip"></span>
                                </p>
                                <p className="modal_messageText">
                                    アペルザサービス内に<br/>コンテンツを"クリップ"しました。
                                </p>
                            </div>
                            <div className="modal_footer">
                                <p className="modal_check">
                                    <input type="checkbox"  ref="clipHide" onChange={this.hideClipSuccessModal}/>次回は表示しない
                                </p>
                            </div>
                        </div>
                </Modal>
                <Modal
                    isOpen={this.state.isClipHideOpen}
                    onAfterOpen={this.afterClipHideModal}
                    onRequestClose={this.closeClipHideModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper bgWhite modal_shortMessage" : "modal_wrapper bgWhite modal_shortMessage"}
                    style={customStyle}
                    contentLabel="Copy Clip Modal"
                    ref="clipHideModal">
                    <div className="modal" ref="clipHode">
                        <div className="modal_body">
                            <p>
                                <span className="icon icon-white icon-clip"></span>{this.props.serviceId == 3 ? "製品名とURLをクリップしました" : this.props.serviceId == 5 ? "カタログをクリップしました" : "記事をクリップしました。"}
                            </p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isClipYetLoginOpen}
                    onAfterOpen={this.afterClipYetLoginModal}
                    onRequestClose={this.closeClipYetLoginModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper" : "modal_wrapper"}
                    style={customStyle}
                    contentLabel="Clip Modal"
                    isLogin={this.state.isLogin}
                    ref="clipYetLoginModal">
                    <div className="modal modal-s" ref="clipYetLogin">
                        <div className="modal_title">
                            <p>Myページにクリップ</p>
                            <p className="modal_closeBtn"><span className="icon icon-close" onClick={this.closeClipYetLoginModal}></span></p>
                        </div>
                        <div className="modal_body">
                            <p>MyページにクリップするにはアペルザIDでのログインが必要です、アペルザIDをお持ちでないお客様は新規登録が必要になります。</p>
                        </div>
                        <div className="modal_footer">
                            <p className="modal_submitBtn"><a href={this.state.loginUrl} className="btn btn-m btn-fill btn-txt-rev">アペルザIDでログイン / 新規登録する</a></p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isMailClipOpen}
                    onAfterOpen={this.afterMailClipModal}
                    onRequestClose={this.closeMailClipModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper" : "modal_wrapper"}
                    style={customStyle}
                    contentLabel="Mail Clip Modal"
                    ref="mailClipModal">
                    <div className="modal"  ref="mail">
                        <SendEmailForm
                            fields={this.state.fields}
                            validations={this.state.validations}
                            serviceId={this.props.serviceId}
                            onChange={this.fieldChange}
                            onValidation={this.validationChange}
                            onValid={(email) => this.onMailClipSubmit(email)}
                            onInvalid={undefined}
                            closeMailClip={this.closeMailClipModal}
                            itemPageShown={itemPageShown}
                        />
                    </div>

                </Modal>
                <Modal
                    isOpen={this.state.isMailClipSuccessOpen}
                    onAfterOpen={this.afterMailClipSuccessModal}
                    onRequestClose={this.closeMailClipSuccessModal.bind(this)}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper modal_wrapper_bgGreen" : "modal_wrapper modal_wrapper_bgGreen"}
                    style={customStyle}
                    contentLabel="Mail Clip Modal"
                    ref="mailClipSuccessModal">
                    <div className="modal modal-message" ref="mailSuccess">
                        <div className="modal_body">
                            <p className="modal_closeBtn"><span className="icon icon-close" onClick={this.closeMailClipSuccessModal.bind(this)}></span></p>
                            <p className="modal_messageIcon"><span className="icon icon-xl icon-white icon-mail"></span></p>
                            <p className="modal_messageText"><span>ご指定のメールアドレスに</span><br/><span>コンテンツURLを送信しました。</span></p>
                        </div>
                        <div className="modal_footer">
                            <p className="modal_check"><input type="checkbox" ref="mailClipHide" onChange={this.hideMailClipSuccessModal}/>次回は表示しない</p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isMailClipHideOpen}
                    onAfterOpen={this.afterMailClipHideModal}
                    onRequestClose={this.closeMailClipHideModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper bgWhite modal_shortMessage" : "modal_wrapper bgWhite modal_shortMessage"}
                    style={customStyle}
                    contentLabel="Copy Clip Modal"
                    ref="mailClipHideModal">
                    <div className="modal" ref="mailClipHode">
                        <div className="modal_body">
                            <p>
                                <span className="icon icon-white icon-clip"></span>{this.props.serviceId == 3 ? "製品名とURLを送信しました" : this.props.serviceId == 5 ? "カタログのURLを送信しました" : "記事のURLを送信しました"}
                            </p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isClipboardCopyOpen}
                    onAfterOpen={this.afterClipboardCopyModal}
                    onRequestClose={this.closeClipboardCopyModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper bgWhite modal_shortMessage" : "modal_wrapper bgWhite modal_shortMessage"}
                    style={customStyle}
                    contentLabel="Copy Clip Modal"
                    ref="clipboardCopyModal">
                    <div className="modal" ref="clipboard">
                        <div className="modal_body">
                            <p>
                                <span className="icon icon-white icon-clip"></span>{this.props.serviceId == 3 ? "製品名とURLをコピーしました" : "記事のURLをコピーしました"}
                            </p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isAddBookmarkOpen}
                    onAfterOpen={this.afterAddBookmarkModal}
                    onRequestClose={this.closeAddBookmarkModal}
                    shouldCloseOnOverlayClick={true}
                    className= {this.props.serviceId == 5 ? "ac modal_wrapper" : "modal_wrapper"}
                    style={customStyle}
                    contentLabel="Clip Modal"
                    ref="addBookmarkModal">
                    <div className="modal modal-s" ref="clipYetLogin">
                        <div className="modal_title">
                            <p>ブックマーク</p>
                            <p className="modal_closeBtn"><span className="icon icon-close" onClick={this.closeAddBookmarkModal}></span></p>
                        </div>
                        <div className="modal_body">
                            <p>このブラウザへのお気に入り追加ボタンは、Google Chrome/Safari等には対応しておりません。<br/>Google Chrome/Safariの場合、CtrlキーとDキーを同時に押してください。<br/>その他の場合はご自身のブラウザからお気に入りへ追加下さい</p>
                        </div>
                    </div>
                </Modal>
                <div className="navBaloon" ref="clipSuccessBaloon" style={displayNone}>
                    <p>クリップした{this.props.serviceId == 3 ? "製品" : this.props.serviceId == 5 ? "カタログ" :"記事"}は</p>
                    <p>こちらから</p>
                </div>
            </ClipMenu>
        );
    }
}







// WEBPACK FOOTER //
// ./clip.jsx